import { Divider, Menu, MenuList, useOutsideClick, VStack } from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import { ChakraSelectButton } from '../../../common/ChakraSelect/ChakraSelectButton';
import { getUpdatedObjectFilterBedroomsParams } from '../../../../services/Objects/BedroomsSelectorService';
import { ObjectsParams } from '../../../../types/ParamsTypes';
import { Stepper } from '../../../common/Stepper/Stepper';
import { CtaFilterButtons } from '../CtaFilterButtons/CtaFilterButtons';

export interface BedroomsSelectorProps {
  objectsParams: ObjectsParams;
  onFilterChange: (objectFilterParams: ObjectsParams) => void;
}

export const BedroomsSelector = (props: BedroomsSelectorProps): JSX.Element => {
  const { objectsParams, onFilterChange } = props;
  const [internalObjectsParams, setInternalObjectsParams] = useState<ObjectsParams>(objectsParams);
  const { numberOfBedrooms } = internalObjectsParams;
  const [information, setInformation] = useState<string>('Beliebig');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = React.useRef();

  useOutsideClick({
    // @ts-ignore
    ref: ref,
    handler: () => setIsOpen(false),
  });

  const handleChange = useCallback(
    (name, value, operator) => {
      const result = getUpdatedObjectFilterBedroomsParams(internalObjectsParams, value, operator);
      setInternalObjectsParams(result);
    },
    [internalObjectsParams],
  );

  const handleFilterChange = useCallback(() => {
    onFilterChange(internalObjectsParams);
    setIsOpen(false);
  }, [internalObjectsParams, setIsOpen]);

  const handleCancel = useCallback(() => {
    setIsOpen(false);
    setInternalObjectsParams(objectsParams);
  }, [setIsOpen, objectsParams]);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  useEffect(() => {
    if (objectsParams.numberOfBedrooms > 0) {
      setInformation(`${objectsParams.numberOfBedrooms} Schlafzimmer`);
    } else {
      setInformation('Beliebig');
    }
  }, [objectsParams.numberOfBedrooms]);

  useEffect(() => {
    setInternalObjectsParams(objectsParams);
  }, [objectsParams]);

  return (
    <Menu matchWidth={true} isOpen={isOpen} onOpen={handleOpen} onClose={handleCancel}>
      <ChakraSelectButton headline={'Wie viele Schlafzimmer?'} information={information} />
      <MenuList p={4}>
        <VStack
          alignItems={'flex-start'}
          // @ts-ignore
          ref={ref}>
          <Stepper
            title={'Schlafzimmer'}
            handleChange={handleChange}
            name={'bedrooms'}
            value={numberOfBedrooms}
            boxSize={10}
          />
          <Divider />
          <CtaFilterButtons
            size={'sm'}
            handleCancel={handleCancel}
            handleFilterChange={handleFilterChange}
          />
        </VStack>
      </MenuList>
    </Menu>
  );
};
